// NOTE: パスの指定
export const API_PATH = {
  ENQUETE_ANSWERER_GROUP: '/manage/enquete-answerer-group',
  ORGANIZATION_FUTURE: '/manage/complementary-organization',
  CUSTOMER_MANAGEMENT: '/manage/customer-management',
  ID_ISSUANCE_MANAGEMENT: '/manage/id-issuance-management',
};
